import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["rioConfig", "headerDataSource"];
import React, { useEffect } from 'react';
import { breakpoints } from '@chegg-ui/theme';
import { sessionLogger } from '@chegg-ui/utils';
import { updateAuthState, initializeRioClient } from '@chegg-me-components/utils';
import { ApolloProvider } from '@apollo/client';
import Media from 'react-media';
import HeaderLogoLink from '../shared/HeaderLogoLink';
import HeaderShell from '../shared/HeaderShell';
import { configureHeaderGQLServer } from '../shared/configureHeaderGQLServer';
import DesktopUserMenu from '../shared/desktop/DesktopUserMenu';
import UserInfoLoader from '../shared/desktop/UserInfoLoader';
import getSecondaryNavLinks from '../shared/getSecondaryNavLinks';
import MobileHamburgerMenu from '../shared/mobile/MobileHamburgerMenu';
import useApolloClient from '../shared/useApolloClient';
import useHeaderData from '../shared/useHeaderData';
export var NoNavigationHeaderPresentational = function NoNavigationHeaderPresentational(_ref) {
  var user = _ref.user,
      envUrl = _ref.envUrl,
      mainContentId = _ref.mainContentId,
      navType = _ref.navType,
      pageTrackId = _ref.pageTrackId,
      onClickSignIn = _ref.onClickSignIn,
      onClickSignUp = _ref.onClickSignUp,
      onClickSignOut = _ref.onClickSignOut,
      skipDataQuery = _ref.skipDataQuery,
      serverRenderAsMobile = _ref.serverRenderAsMobile,
      dataTest = _ref['data-test'];

  var _useHeaderData = useHeaderData(envUrl, user, 0, // we don't present cart info in this variant
  onClickSignOut, skipDataQuery, navType),
      userData = _useHeaderData.userData,
      signOutUser = _useHeaderData.signOutUser,
      userDataLoading = _useHeaderData.userDataLoading;

  var userLinks = getSecondaryNavLinks({
    navType: navType,
    user: user || (userData === null || userData === void 0 ? void 0 : userData.userProfile),
    onClickSignUp: onClickSignUp,
    onClickSignOut: signOutUser,
    limitNavigation: true
  });
  var logoLink = /*#__PURE__*/React.createElement(HeaderLogoLink, {
    envUrl: envUrl,
    navType: navType,
    onClick: function onClick() {
      sessionLogger.event(envUrl, pageTrackId, {
        navigation_click: "".concat(navType, "-logo")
      });
    }
  });
  return /*#__PURE__*/React.createElement(HeaderShell, {
    mainContentId: mainContentId,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(Media, {
    query: {
      maxWidth: breakpoints.md.max
    },
    defaultMatches: serverRenderAsMobile
  }, function (matches) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, matches ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileHamburgerMenu, {
      navType: navType,
      envUrl: envUrl,
      pageTrackId: pageTrackId,
      user: user || (userData === null || userData === void 0 ? void 0 : userData.userProfile),
      onClickSignIn: onClickSignIn,
      navLinks: [],
      userLinks: userLinks,
      userDataLoading: userDataLoading
    }), logoLink) : /*#__PURE__*/React.createElement(React.Fragment, null, logoLink, userDataLoading ? /*#__PURE__*/React.createElement(UserInfoLoader, null) : /*#__PURE__*/React.createElement(DesktopUserMenu, {
      navType: navType,
      user: user || (userData === null || userData === void 0 ? void 0 : userData.userProfile),
      envUrl: envUrl,
      pageTrackId: pageTrackId,
      onClickSignIn: onClickSignIn,
      userLinks: userLinks
    })));
  }));
};
NoNavigationHeaderPresentational.displayName = 'NoNavigationHeaderPresentational';

var NoNavigationHeader = function NoNavigationHeader(_ref2) {
  var rioConfig = _ref2.rioConfig,
      headerDataSource = _ref2.headerDataSource,
      passThoughProps = _objectWithoutProperties(_ref2, _excluded);

  useEffect(function () {
    /**
     * Initialize Rio Client
     */

    /* istanbul ignore next */
    if (rioConfig) {
      initializeRioClient(rioConfig);
    }
    /**
     * This function will update the rio-client
     * state if user is logged in
     */


    updateAuthState();
  }, []);

  var _useApolloClient = useApolloClient({
    headerDataSource: configureHeaderGQLServer(headerDataSource)
  }),
      client = _useApolloClient.client,
      existingClient = _useApolloClient.existingClient;
  /* istanbul ignore next */


  return existingClient ? /*#__PURE__*/React.createElement(NoNavigationHeaderPresentational, passThoughProps) : /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, /*#__PURE__*/React.createElement(NoNavigationHeaderPresentational, passThoughProps));
};

NoNavigationHeader.displayName = 'NoNavigationHeader';
export default NoNavigationHeader;